<template>
  <page-edicion>
    <formulario-datos @guardado="volver" />
  </page-edicion>
</template>

<script>
import FormularioDatos from "./FormularioDatos.vue";

export default {
  components: { FormularioDatos },
  methods: {
    volver() {
      this.$router.push({ path: "/modulos" });
    },
  },
};
</script>
